import { useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@/fontawesome'

export default function EconomicCalendar() {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const container = containerRef.current
    if (container === null) return

    // Check if script already exists to prevent duplicates
    const existingScript = container.querySelector('script')
    if (existingScript !== null) {
      return
    }

    // Detect current dark mode state
    const isDarkMode = document.documentElement.classList.contains('dark')
    const colorTheme = isDarkMode ? 'dark' : 'light'

    // Create and configure the TradingView script
    const script = document.createElement('script')
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-events.js'
    script.type = 'text/javascript'
    script.async = true
    script.innerHTML = `
      {
        "colorTheme": "${colorTheme}",
        "isTransparent": false,
        "locale": "de_DE",
        "countryFilter": "us",
        "importanceFilter": "-1,0,1",
        "width": "100%",
        "height": "800"
      }`

    container.appendChild(script)
  }, [])

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 sm:p-8 shadow-md border border-gray-200 dark:border-gray-700">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-purple-100 dark:bg-purple-900/50 rounded-lg flex items-center justify-center">
          <FontAwesomeIcon icon={faCalendarAlt} className="w-6 h-6 text-purple-600 dark:text-purple-400" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            Wirtschaftskalender
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Wichtige Wirtschaftstermine und Datenveröffentlichungen
          </p>
        </div>
      </div>

      <div className="tradingview-widget-container" ref={containerRef} style={{ height: '800px' }}>
        <div className="tradingview-widget-container__widget"></div>
      </div>

      <div className="mt-4 text-xs text-gray-500 dark:text-gray-400 text-center tradingview-widget-copyright">
        <a
          href="https://de.tradingview.com/economic-calendar/"
          rel="noopener nofollow"
          target="_blank"
          className="text-purple-600 dark:text-purple-400 hover:underline"
        >
          Track all markets on TradingView
        </a>
      </div>
    </div>
  )
}
